<template>
  <section class="download-report">
    <div class="download-report__wrapper">
      <span class="download-report__text">{{ text }}</span>
      <div class="download-report__icon">
        <BaseIcon name="get_app" size="20"></BaseIcon>
      </div>
    </div>
    <div class="download-report__shape">
      <div class="download-report__shape--rectangle">
        <RectangleSVG />
      </div>
    </div>
  </section>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import RectangleSVG from '@/assets/svg/shapes/rectangle-full.svg?inline'
export default {
  name: 'DownloadReport',
  components: {
    RectangleSVG,
    BaseIcon
  },
  props: {
    text: {
      type: String,
      default: 'Download Corporate Responsibility Report 2018/19'
    }
  }
}
</script>

<style lang="postcss">
.download-report {
  @apply relative overflow-hidden flex bg-gradient-tr-primary cursor-pointer justify-center items-center py-4 px-6;
}
.download-report__wrapper {
  @apply z-10 flex items-center;
}
.download-report__text {
  @apply text-white text-lg font-semibold pr-4;
}
.download-report__icon {
  @apply text-primary no-underline bg-white p-2 rounded-full flex justify-center items-center;
}
.download-report__shape {
  @apply inset-0 absolute z-0;
}
.download-report__shape svg {
  @apply absolute right-0 hidden;
  top: -24px;
  transform: rotate(16deg) scale(1.4);
}
.download-report__shape--rectangle svg {
  @apply block;
}
.download-report:hover .download-report__shape {
  transform: scale(1.1);
}
@screen md {
  .download-report__text {
    @apply text-xl;
  }
}
</style>
